window.addEventListener('ionKeyboardDidShow', () => {
  // ev.keyboardHeight
  document.body.classList.add('c-keyboard-opened');
});

window.addEventListener('ionKeyboardDidHide', () => {
  document.body.classList.remove('c-keyboard-opened');
});